// Section color theming — used throughout the app for visual differentiation
export const SECTIONS = {
  dashboard: {
    id: 'dashboard',
    label: 'Dashboard',
    color: '#42CDD7',           // Teal (i3 brand)
    colorSoft: 'rgba(66,205,215,0.12)',
    colorBg: 'rgba(66,205,215,0.06)',
    ring: 'rgba(66,205,215,0.30)',
  },
  training: {
    id: 'training',
    label: 'Kestral K4 Resource',
    color: '#2563EB',           // Blue
    colorSoft: 'rgba(37,99,235,0.12)',
    colorBg: 'rgba(37,99,235,0.06)',
    ring: 'rgba(37,99,235,0.30)',
  },
  mbs: {
    id: 'mbs',
    label: 'MBS Monitor',
    color: '#16A34A',           // Green
    colorSoft: 'rgba(22,163,74,0.12)',
    colorBg: 'rgba(22,163,74,0.06)',
    ring: 'rgba(22,163,74,0.30)',
  },
  sops: {
    id: 'sops',
    label: 'SOPs',
    color: '#7C3AED',           // Purple
    colorSoft: 'rgba(124,58,237,0.12)',
    colorBg: 'rgba(124,58,237,0.06)',
    ring: 'rgba(124,58,237,0.30)',
  },
  contracts: {
    id: 'contracts',
    label: 'HR & Contracts',
    color: '#D97706',           // Amber
    colorSoft: 'rgba(217,119,6,0.12)',
    colorBg: 'rgba(217,119,6,0.06)',
    ring: 'rgba(217,119,6,0.30)',
  },
  compliance: {
    id: 'compliance',
    label: 'Compliance',
    color: '#DC2626',           // Red — regulatory / audit tone
    colorSoft: 'rgba(220,38,38,0.12)',
    colorBg: 'rgba(220,38,38,0.06)',
    ring: 'rgba(220,38,38,0.30)',
  },
  consent: {
    id: 'consent',
    label: 'Consent forms',
    color: '#7C2D12',           // Deep umber — formal / legal seal
    colorSoft: 'rgba(124,45,18,0.12)',
    colorBg: 'rgba(124,45,18,0.06)',
    ring: 'rgba(124,45,18,0.30)',
  },
  management: {
    id: 'management',
    label: 'Management',
    color: '#0E7490',           // Cyan-slate (admin / executive)
    colorSoft: 'rgba(14,116,144,0.12)',
    colorBg: 'rgba(14,116,144,0.06)',
    ring: 'rgba(14,116,144,0.30)',
  },
  preparation: {
    id: 'preparation',
    label: 'Patient Prep',
    color: '#0891B2',           // Sky — patient-facing / reassuring
    colorSoft: 'rgba(8,145,178,0.12)',
    colorBg: 'rgba(8,145,178,0.06)',
    ring: 'rgba(8,145,178,0.30)',
  },
  referrals: {
    id: 'referrals',
    label: 'Referral Base',
    color: '#9333EA',           // Vivid violet — outreach / marketing
    colorSoft: 'rgba(147,51,234,0.12)',
    colorBg: 'rgba(147,51,234,0.06)',
    ring: 'rgba(147,51,234,0.30)',
  },
  equipment: {
    id: 'equipment',
    label: 'Equipment',
    color: '#475569',           // Slate — hardware / engineering
    colorSoft: 'rgba(71,85,105,0.12)',
    colorBg: 'rgba(71,85,105,0.06)',
    ring: 'rgba(71,85,105,0.30)',
  },
  people: {
    id: 'people',
    label: 'People',
    color: '#0EA5E9',           // Sky-blue — workforce / individuals
    colorSoft: 'rgba(14,165,233,0.12)',
    colorBg: 'rgba(14,165,233,0.06)',
    ring: 'rgba(14,165,233,0.30)',
  },
  anticoag: {
    id: 'anticoag',
    label: 'Anticoag',
    color: '#BE123C',           // Crimson — bleeding / haemostasis tone
    colorSoft: 'rgba(190,18,60,0.12)',
    colorBg: 'rgba(190,18,60,0.06)',
    ring: 'rgba(190,18,60,0.30)',
  },
  roster: {
    id: 'roster',
    label: 'Rostering',
    color: '#0d6efd',           // Cobalt — scheduling / planning
    colorSoft: 'rgba(13,110,253,0.12)',
    colorBg: 'rgba(13,110,253,0.06)',
    ring: 'rgba(13,110,253,0.30)',
  },
  // Iter 122 — top-level hubs that group related sub-sections
  clinical: {
    id: 'clinical',
    label: 'Clinical',
    color: '#0F766E',           // Deep teal — patient-facing clinical workflows
    colorSoft: 'rgba(15,118,110,0.12)',
    colorBg: 'rgba(15,118,110,0.06)',
    ring: 'rgba(15,118,110,0.30)',
  },
  knowledge: {
    id: 'knowledge',
    label: 'Knowledge',
    color: '#4F46E5',           // Indigo — reference, learning, lookup
    colorSoft: 'rgba(79,70,229,0.12)',
    colorBg: 'rgba(79,70,229,0.06)',
    ring: 'rgba(79,70,229,0.30)',
  },
  operations: {
    id: 'operations',
    label: 'Operations',
    color: '#0d2644',           // Logo navy — i3 brand dark blue
    colorSoft: 'rgba(13,38,68,0.12)',
    colorBg: 'rgba(13,38,68,0.06)',
    ring: 'rgba(13,38,68,0.30)',
  },
};

export function sectionForPath(pathname) {
  // Iter 122 — top-level hub matching takes priority for the breadcrumb pill.
  if (pathname === '/clinical') return SECTIONS.clinical;
  if (pathname === '/knowledge') return SECTIONS.knowledge;
  if (pathname === '/operations') return SECTIONS.operations;
  if (pathname === '/' || pathname === '/dashboard-home') return SECTIONS.dashboard;
  if (pathname.startsWith('/management') || pathname === '/dashboard' || pathname.startsWith('/dashboard/') || pathname === '/practice-settings') return SECTIONS.management;
  if (pathname.startsWith('/mbs')) return SECTIONS.mbs;
  if (pathname.startsWith('/sops')) return SECTIONS.sops;
  if (pathname.startsWith('/contracts')) return SECTIONS.contracts;
  if (pathname.startsWith('/compliance')) return SECTIONS.compliance;
  if (pathname.startsWith('/consent')) return SECTIONS.consent;
  if (pathname.startsWith('/preparation')) return SECTIONS.preparation;
  if (pathname.startsWith('/referrals')) return SECTIONS.referrals;
  if (pathname.startsWith('/equipment')) return SECTIONS.equipment;
  if (pathname.startsWith('/people')) return SECTIONS.people;
  if (pathname.startsWith('/anticoag')) return SECTIONS.anticoag;
  if (pathname.startsWith('/roster')) return SECTIONS.roster;
  if (pathname.startsWith('/k4') || pathname.startsWith('/module') || pathname === '/search' || pathname === '/chat' || pathname.startsWith('/quick-ref')) return SECTIONS.training;
  return SECTIONS.dashboard;
}

// Iter 122 — Returns which top-level HUB a path belongs to (for the nav
// active-state). Different from sectionForPath which returns the granular
// theme.
export const HUB_MEMBERSHIP = {
  clinical: ['/consent', '/anticoag', '/preparation'],
  knowledge: ['/sops', '/k4', '/module', '/search', '/chat', '/quick-ref', '/mbs', '/referrals'],
  operations: ['/roster', '/equipment', '/people', '/letterhead', '/letterhead-generator', '/management', '/golive', '/permissions'],
  compliance: ['/compliance'],
};

export function hubForPath(pathname) {
  if (pathname === '/' || pathname === '/dashboard-home') return 'dashboard';
  if (pathname === '/clinical') return 'clinical';
  if (pathname === '/knowledge') return 'knowledge';
  if (pathname === '/operations') return 'operations';
  for (const [hub, paths] of Object.entries(HUB_MEMBERSHIP)) {
    if (paths.some(p => pathname === p || pathname.startsWith(p + '/'))) return hub;
  }
  return 'dashboard';
}
